import ExMapsController from './ex_maps_controller'

export default class extends ExMapsController {
  setTarget ({ target }: any): void {
    this.targetType = this.targetType === 'ExAllocation' ? 'ExGroup' : 'ExAllocation'
    target.innerHTML = this.targetType === 'ExAllocation' ? 'Show Groups' : 'Show Sensors'
    this.setHeatmapData()
  }
}
